module.exports = __webpack_public_path__ + "static/media/track-gecko.c975d55b.png";